import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, filter } from 'rxjs/operators';
import * as release from '@webapp/sdk/release';
import { Action } from 'redux';
import {
  ListReleasesDeactivatedArtist,
  ListReleasesDeactivatedArtistSuccess,
  ListReleasesDeactivatedArtistError,
} from '../action-creators';
import { LIST_RELEASES_DEACTIVATED_ARTIST } from '../actions';

export const listReleasesDeactivatedArtistEpic = (
  action$: Observable<Action>
) =>
  action$.pipe(
    ofType<Action, ListReleasesDeactivatedArtist>(
      LIST_RELEASES_DEACTIVATED_ARTIST
    ),
    filter((action) => !!action.artistId),
    mergeMap(async (action) => {
      try {
        const releases = await release.list(action.artistId, 'all');

        return new ListReleasesDeactivatedArtistSuccess(
          releases,
          action.artistId
        );
      } catch (err) {
        return new ListReleasesDeactivatedArtistError((err as Error).message);
      }
    })
  );
